import { IFieldOption } from "features/assets/model/types/assets"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "shared/config/store"
import { 
  buildSearchByAiTagsUrl, 
  buildSearchByStatusUrl, 
  buildSearchByTagsUrl 
} from "shared/utils/urlUtils"

import {
  clearPrevStateSearch,
  fetchSearchResultsByLabel,
  fetchSearchResultsByTagsOrStatuses,
  setIsSearchInputActive,
  setIsSearchPage,
  setSearchAiTags,
  setSearchStatus,
  setSearchTags,
  setSearchTagsType
} from "../model/slice/searchSlice"
import { SearchTagsType, TagType } from "../model/types/search"

export const useOnClickTag = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleAiTagClick = async (tag: IFieldOption) => {
    const label = typeof tag === 'string' ? tag : tag.name

    await dispatch(fetchSearchResultsByLabel({ label }))

    navigate(buildSearchByAiTagsUrl(label))
    dispatch(setIsSearchPage(true))
    dispatch(setSearchAiTags([
      typeof tag === 'string'
        ? { name: tag, id: tag, type: TagType.AI }
        : tag
    ]))
    dispatch(setSearchTagsType(SearchTagsType.CONTAIN))
    dispatch(clearPrevStateSearch())

    dispatch(setIsSearchInputActive(false))
  }

  const handleTagClick = async (tag: IFieldOption | { id: string; label: string; value: string }) => {

    if ('label' in tag) {
      tag = {
        id: tag.id,
        value: tag.label,
        type: TagType.TAG
      }
    }

    await dispatch(fetchSearchResultsByTagsOrStatuses({
      tagIds: [tag.id],
      searchTagsType: SearchTagsType.CONTAIN,
      searchType: 'tags'
    }))

    navigate(buildSearchByTagsUrl([tag.id], SearchTagsType.CONTAIN))
    dispatch(setSearchTags([tag]))
    dispatch(setSearchTagsType(SearchTagsType.CONTAIN))
    dispatch(setIsSearchPage(true))
    dispatch(clearPrevStateSearch())

    dispatch(setIsSearchInputActive(false))
  }

  const handleStatusClick = async (status: IFieldOption) => {
    await dispatch(fetchSearchResultsByTagsOrStatuses({
      tagIds: [status.id],
      searchTagsType: SearchTagsType.CONTAIN,
      searchType: 'status'
    }))

    navigate(buildSearchByStatusUrl([status.id], SearchTagsType.CONTAIN))
    dispatch(setSearchStatus([status]))
    dispatch(setSearchTagsType(SearchTagsType.CONTAIN))
    dispatch(setIsSearchPage(true))
    dispatch(clearPrevStateSearch())

    dispatch(setIsSearchInputActive(false))
  }

  return {
    handleAiTagClick,
    handleTagClick,
    handleStatusClick
  }
}
